<div class="flex h-[100dvh] w-full flex-col overflow-hidden">
  <div class="relative min-h-0 flex-1 overflow-y-auto bg-inherit">
    <router-outlet></router-outlet>
  </div>
  @defer (on idle; on timer(2s)) {
    <app-install-banner class="w-full shrink-0" />
  } @placeholder {
    <div class="h-0 w-0"></div>
  }
</div>
